var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('MainLayout', {
    attrs: {
      "showNavigation": false
    }
  }, [_c('div', {
    staticClass: "recording-mode-wrapper d-flex flex-column align-center justify-center"
  }, [_c('h1', {
    staticClass: "recording-mode-title"
  }, [_vm._v("How will you record?")]), _c('div', {
    staticClass: "options-container"
  }, [_c('div', {
    staticClass: "card-wrapper"
  }, [_c('div', {
    staticClass: "option-card pa-6 d-flex flex-column align-center",
    on: {
      "click": _vm.selectMonocular
    }
  }, [_c('v-icon', {
    staticClass: "mb-4 option-icon",
    attrs: {
      "size": "64"
    }
  }, [_vm._v("mdi-cellphone")]), _c('div', {
    staticClass: "title-row mb-2"
  }, [_c('h2', {
    staticClass: "option-title mb-0"
  }, [_vm._v("Monocular")]), _c('v-chip', {
    staticClass: "beta-chip ml-2",
    attrs: {
      "x-small": "",
      "color": "warning",
      "text-color": "black"
    }
  }, [_vm._v(" Beta ")])], 1), _c('p', {
    staticClass: "text-center option-description"
  }, [_vm._v(" Record with a single phone. Simplified setup, no calibration needed. "), _c('strong', [_vm._v("Requires OpenCap app 2.0+ from the App Store.")])]), _c('v-btn', {
    staticClass: "mt-4 select-button",
    attrs: {
      "large": ""
    }
  }, [_vm._v("Select")])], 1), _c('a', {
    staticClass: "best-practices-link",
    attrs: {
      "href": "https://www.opencap.ai/best-practices?variant=monocular",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(" Read monocular best practices ")])]), _c('div', {
    staticClass: "card-wrapper"
  }, [_c('div', {
    staticClass: "option-card pa-6 d-flex flex-column align-center",
    on: {
      "click": _vm.selectMultiPhone
    }
  }, [_c('div', {
    staticClass: "d-flex justify-center align-center mb-4 icon-container"
  }, [_c('v-icon', {
    staticClass: "mr-2 option-icon",
    attrs: {
      "size": "64"
    }
  }, [_vm._v("mdi-cellphone")]), _c('v-icon', {
    staticClass: "option-icon",
    attrs: {
      "size": "64"
    }
  }, [_vm._v("mdi-cellphone")])], 1), _c('div', {
    staticClass: "title-row mb-2"
  }, [_c('h2', {
    staticClass: "option-title mb-0"
  }, [_vm._v("2+ phones")])]), _c('p', {
    staticClass: "text-center option-description"
  }, [_vm._v(" Record with multiple phones for higher accuracy. Requires calibration. ")]), _c('v-btn', {
    staticClass: "mt-4 select-button",
    attrs: {
      "large": ""
    }
  }, [_vm._v("Select")])], 1), _c('a', {
    staticClass: "best-practices-link",
    attrs: {
      "href": "https://www.opencap.ai/best-practices",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(" Read 2+ phones best practices ")])])]), _c('v-btn', {
    staticClass: "recording-mode-back",
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          name: 'SelectSession'
        });
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-arrow-left")]), _vm._v(" " + _vm._s(_vm.backLabel) + " ")], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }